<template>
  <vl-grid v-vl-spacer:bottom.medium>
    <vl-column width="12" width-xs="12">
      <vl-title tag-name="h2">{{ $t('deliveryprocessdefinition.geckoSync.additionalTests') }}</vl-title>
    </vl-column>
    <vl-column width="12" width-xs="12">
      <vl-accordion-list>
        <vl-accordion-list-item v-for="(entity, i) in deliveryEntities" :id="i" :key="i">
          <vl-accordion
            :id="i.toString()"
            :title="getEntityLabel(entity)"
            :open="getStandardTestsForEntity(entity).length > 0"
          >
            <GeckoTestStandardTestsForEntity
              :standardTests="getStandardTestsForEntity(entity)"
              :standardTestTypes="standardTestTypes"
              :deliveryEntity="entity"
              :isReadOnly="isReadOnly"
              :onCheckboxChange="onCheckboxChanged"
              :onFormSubmit="onFormSubmit"
              :onDeleteTest="onDeleteTest"
              :onAfterChange="onAfterChange"
            ></GeckoTestStandardTestsForEntity>
          </vl-accordion>
        </vl-accordion-list-item>
      </vl-accordion-list>
    </vl-column>
  </vl-grid>
</template>

<script lang="ts" setup>
import { reactive, watch } from 'vue';
import { DeliveryEntityDetailDto, GeckoStandardTestTypeDto, GeckoTestDto } from '@/api/backoffice/clients';
import GeckoTestStandardTestsForEntity from '../../subcomponents/gecko-test-standard-tests/GeckoTestStandardTestsForEntity.vue';
import { GeckoStandardTestFormDto } from './GeckoStandardTestForm.vue';
import { DeliveryQualityCheckData } from '../gecko-test-datatable/GeckoTestActiveToggle.vue';

const props = defineProps<{
  standardTests: GeckoTestDto[];
  standardTestTypes: GeckoStandardTestTypeDto[];
  deliveryEntities: DeliveryEntityDetailDto[];
  isReadOnly: boolean;
  onCheckboxChange?: (evt: DeliveryQualityCheckData) => Promise<boolean>;
  onFormSubmit?: (dto: GeckoStandardTestFormDto) => Promise<boolean>;
  onDeleteTest?: (test: GeckoTestDto) => Promise<boolean>;
  onAfterChange?: () => Promise<void>;
}>();

const data = reactive({
  standardTests: [] as GeckoTestDto[]
});

watch(
  () => props.standardTests,
  () => {
    data.standardTests = props.standardTests?.map((test) => ({ ...test })) || [];
  },
  { immediate: true }
);

const getEntityLabel = (entity: DeliveryEntityDetailDto): string => {
  return `Entiteit ${entity.code} - ${entity.label}`;
};

const getStandardTestsForEntity = (entity: DeliveryEntityDetailDto): GeckoTestDto[] => {
  return data.standardTests.filter((test) => test.deliveryEntityId == entity.id) || [];
};

const onCheckboxChanged = async (deliveryQualityCheckData: DeliveryQualityCheckData): Promise<boolean> => {
  const succeeded = await props.onCheckboxChange?.(deliveryQualityCheckData);

  if (succeeded) {
    updateDefaultTestAvailability(deliveryQualityCheckData.test.code, deliveryQualityCheckData.isEnabled);
  }

  return succeeded;
};

const updateDefaultTestAvailability = (testCode: string, isEnabled: boolean) => {
  data.standardTests.forEach((test) => {
    if (test.test.code === testCode) {
      test.test.availability = isEnabled ? 'enabled' : 'disabled';
    }
  });
};
</script>

<style lang="scss" scoped></style>
